import React, { useEffect } from 'react';
import useForm from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Link } from "react-router-dom";

// ui icons
import CreditCard from "@material-ui/icons/CreditCard";
import Subtitles from "@material-ui/icons/Subtitles";
import AttachMoney from "@material-ui/icons/AttachMoney";
import Event from "@material-ui/icons/Event";
import Grade from "@material-ui/icons/Grade";

// ui components
import Slide from "@material-ui/core/Slide";
import Snackbar from "beaktShared/components/Snackbar/Snackbar.js";
import CircularProgress from '@material-ui/core/CircularProgress';
import FormControl from "@material-ui/core/FormControl";
import TextField from '@material-ui/core/TextField';

// core components 
import Card from "beaktShared/components/Card/Card.js";
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import NavPills from "beaktShared/components/NavPills/NavPills.js";
import PagamentoCartao from "beaktClinic/views/Venda/Pagamentos/PagamentoCartao"
import PagamentoDinheiro from "beaktClinic/views/Venda/Pagamentos/PagamentoDinheiro"
import PagamentoCheque from "beaktClinic/views/Venda/Pagamentos/PagamentoCheque"
import PagamentoBoleto from "beaktClinic/views/Venda/Pagamentos/PagamentoBoleto"
import PagamentoOutros from "beaktClinic/views/Venda/Pagamentos/PagamentoOutros"
import Clearfix from 'beaktShared/components/Clearfix/Clearfix';
import SnackbarContent from "beaktShared/components/Snackbar/SnackbarContent.js";

// services
import { transformValueFloattoFormated } from "beaktShared/helpers/masks";
import { UseGetApiSimple } from "beaktShared/services/crudeApiService";

// styles
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/crudeStyle.js";

const useStyles = makeStyles(styles);

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});

export default function AlteracaoVendaPagamento({ detalheVenda, handleVoltar, handleFinalizar }) {
    const { t } = useTranslation();
    const classes = useStyles();
    const { getValues } = useForm({ mode: "onBlur" });

    const [notification, setNotification] = React.useState({
        show: false,
        color: 'info',
        message: ''
    });
    const showNotification = (message, color) => {
        setNotification({
            show: true,
            color: color,
            message: message
        });
        setTimeout(function () {
            setNotification({ show: false });
        }, 6000);
    };
    const [messageReturn, setmessageReturn] = React.useState({
        show: false,
        message: ''
    });
    // Carrega as formas de pagamento
    const [loadingPayments, setloadingPayments] = React.useState(false);
    const [listaFormasPagamento, setlistaFormasPagamento] = React.useState([]);
    const loadFormasPagamento = () => {
        setloadingPayments(true);
        UseGetApiSimple("formaPagamentos/ativos/byestabelecimento/" + detalheVenda.estabelecimentoId).then(result => {
            setloadingPayments(false);
            if (result.status !== 200) {
                showNotification("Não foi possível carregar as formas de pagamento", "danger");
                return;
            }
            else {
                setlistaFormasPagamento(result.data);

                // Carrega os pagamentos já efetuados
                loadTotalizadorPgtos();
            }
        });
    }

    useEffect(() => {
        if (detalheVenda.royaltieId != null) {
            loadTotalizadorPgtos();
            setvinculadoRoyaltie(true);
        } else {
            loadFormasPagamento();
        }
    }, [detalheVenda]);

    const [vinculadoRoyaltie, setvinculadoRoyaltie] = React.useState(false);
    const [pagamentoTEF, setpagamentoTEF] = React.useState(false);
    const [pgto, setpgto] = React.useState();
    const loadTotalizadorPgtos = () => {
        let loadpgto = {
            pagamentos: [],
            totalizadorPagamentos: {
                valorTotalPago: 0,
                valorPendente: 0,
            }
        };

        detalheVenda.pagamentos.map(item => {
            loadpgto.pagamentos.push({
                vendaPagamentoId: item.vendaPagamentoId,
                tipo: item.tipo, //0- Dinheiro / 1-Cartão / 2-Boleto / 3-Cheque / 4-Outros
                valor: item.valor,
                descTipo: item.descricaoFormaPgto,
                parcela: 0
            });
            loadpgto.totalizadorPagamentos.valorTotalPago = loadpgto.totalizadorPagamentos.valorTotalPago + item.valor;

            if (item.descricaoFormaPgto == 'Cartão de Crédito - Beakt ESitef (Online)' || item.descricaoFormaPgto == 'Cartão de Crédito - Beakt Sitef (Maquininha)' || item.descricaoFormaPgto == 'Cartão de Débito - Beakt Sitef (Maquininha)')
                setpagamentoTEF(true)
        });

        loadpgto.totalizadorPagamentos.valorPendente = detalheVenda.valorTotal.toFixed(2) - loadpgto.totalizadorPagamentos.valorTotalPago.toFixed(2);

        setpgto(loadpgto);
    }
    useEffect(() => {
        setNotification({ show: false });
        loadTabsPagamento();
    }, [pgto]);

    // Carrega os TABS de pagamento
    const [tabsPagamento, settabsPagamento] = React.useState([]);
    const loadTabsPagamento = () => {
        let tabs = [];
        if (listaFormasPagamento.filter(({ tipoFormaPagamento, gateway }) => tipoFormaPagamento === 1 && (gateway === "Telefone" || gateway === "Link")).length > 0) {
            tabs.push({
                tabButton: t('sale.card'),
                tabIcon: CreditCard,
                tabContent: (
                    <div>
                        <PagamentoCartao CallloadTotalizadorPgtosCt={AtualizaTotalizadorPgtos} pgto={pgto} formasCartao={listaFormasPagamento.filter(({ tipoFormaPagamento, gateway }) => tipoFormaPagamento === 1 && (gateway === "Telefone" || gateway === "Link"))}></PagamentoCartao>
                    </div>
                )
            });
        }
        if (listaFormasPagamento.filter(({ tipoFormaPagamento }) => tipoFormaPagamento === 0).length > 0) {
            tabs.push({
                tabButton: t('sale.money'),
                tabIcon: AttachMoney,
                tabContent: (
                    <div>
                        <PagamentoDinheiro CallloadTotalizadorPgtos={AtualizaTotalizadorPgtos} pgto={pgto}></PagamentoDinheiro>
                    </div>
                )
            });
        }
        if (listaFormasPagamento.filter(({ tipoFormaPagamento }) => tipoFormaPagamento === 2).length > 0) {
            tabs.push({
                tabButton: t('sale.billet'),
                tabIcon: Event,
                tabContent: (
                    <div>
                        <PagamentoBoleto CallloadTotalizadorPgtosBo={AtualizaTotalizadorPgtos} pgto={pgto}></PagamentoBoleto>
                    </div>
                )
            });
        }
        if (listaFormasPagamento.filter(({ tipoFormaPagamento }) => tipoFormaPagamento === 3).length > 0) {
            tabs.push({
                tabButton: t('sale.check'),
                tabIcon: Subtitles,
                tabContent: (
                    <div>
                        <PagamentoCheque CallloadTotalizadorPgtosCq={AtualizaTotalizadorPgtos} pgto={pgto}></PagamentoCheque>
                    </div>
                )
            });
        }
        if (listaFormasPagamento.filter(({ tipoFormaPagamento }) => tipoFormaPagamento === 4).length > 0) {
            tabs.push({
                tabButton: t('sale.others'),
                tabIcon: Grade,
                tabContent: (
                    <div>
                        <PagamentoOutros CallloadTotalizadorPgtosOutros={AtualizaTotalizadorPgtos} pgto={pgto} formaOutros={listaFormasPagamento.filter(({ tipoFormaPagamento }) => tipoFormaPagamento === 4)}></PagamentoOutros>
                    </div>
                )
            });
        }
        settabsPagamento(tabs);
    }

    //Exibe os pagamentos na tela    
    const handleRemovePagamento = (item) => {
        let listFiltered = pgto.pagamentos.filter(obj => {
            return obj.vendaPagamentoId !== item.vendaPagamentoId;
        });

        let updatepgto = pgto;
        updatepgto.pagamentos = listFiltered;

        AtualizaTotalizadorPgtos(updatepgto);
    }

    //Atualiza dados de pagamento lançados
    const AtualizaTotalizadorPgtos = (_pgto) => {
        let valorPago = 0;

        _pgto.pagamentos.map(item => {
            valorPago = valorPago + item.valor;
        });

        let valorSaldoPendente = detalheVenda.valorTotal.toFixed(2) - valorPago.toFixed(2);

        _pgto.totalizadorPagamentos = {
            valorTotalPago: valorPago,
            valorPendente: valorSaldoPendente,
        };

        setpgto(_pgto);
    }

    const handleReturn = () => {
        handleVoltar(detalheVenda);
    }

    const handleSalvar = () => {
        setmessageReturn({show: false});

        if (pgto.totalizadorPagamentos.valorPendente !== 0) {
            setmessageReturn({
                show: true,
                message: t('O valor de Saldo a Pagar deverá ser zerado!')
            });
            return false;
        }

        if (textMotivo.length < 4) {
            setmessageReturn({
                show: true,
                message: t('Por favor, informe um motivo com pelo menos 4 dígitos para a alteração da venda.')
            });
            motivoInputRef.current.focus();
            return false;
        }

        detalheVenda.pagamentos = pgto.pagamentos;
        detalheVenda.motivo = textMotivo;

        handleFinalizar(detalheVenda);
    }

    const [textMotivo, setTextMotivo] = React.useState('');
    const motivoInputRef = React.useRef(null);

    // Função chamada sempre que o texto muda
    const handleChangeMotivo = (event) => {
        const newText = event.target.value;
        setTextMotivo(newText);
    };

    return (
        <>
            <Snackbar
                place="tr"
                color={notification.color}
                message={notification.message}
                open={notification.show}
                closeNotification={() => setNotification({ show: false })}
                close
            />

            <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                    <div className="subTitulo">
                        <h6>{t('avaliation.payment_details')} </h6>
                    </div>
                </GridItem>
                <GridItem xs={12} sm={8} md={8}>
                    {vinculadoRoyaltie &&
                        <SnackbarContent
                            color={"warning"}
                            message={t('label.Sale_linked_to_a_closing_of_royalties')}
                        />
                    }
                    <Card>
                        <CardBody>
                            <h3>{t('sale.payment_methods')}</h3>

                            <div style={{ maxWidth: '700px', margin: '0 auto' }}>

                                {loadingPayments && <div style={{ textAlign: 'center', paddingTop: '100px' }}>
                                    <CircularProgress />
                                    <br />
                                    <label>{t('label.loading')}...</label>
                                </div>}
                                <NavPills
                                    color="primary"
                                    alignCenter
                                    tabs={tabsPagamento}
                                />
                            </div>
                            {notification.show &&
                                <div><div className="alertErrorEx alertmax">
                                    <p>
                                        {notification.message}
                                    </p>
                                </div><br /></div>
                            }
                        </CardBody>
                    </Card>
                </GridItem>
                <GridItem xs={12} sm={4} md={4}>
                    <Card>
                        <CardBody>{
                            pagamentoTEF &&
                                <SnackbarContent
                                    color={"warning"}
                                    message={t('label.Payments_on_Sitef_and_E-sitef_cannot_be_changed')}
                                />
                            }
                            <h4>{t('sale.payments_made')}</h4>

                            {pgto && pgto.pagamentos.map(item => (
                                <div key={item.vendaPagamentoId}>
                                    <div className={classes.boxItemPg}>
                                        <div className={classes.descForma}>
                                            {item.descTipo}
                                        </div>
                                        <div className={classes.valuePg}>
                                            <small>{t('label.money_symbol')}</small> {transformValueFloattoFormated(item.valor)}
                                        </div>
                                        {
                                            (detalheVenda.royaltieId == null && item.descTipo !== 'Cartão de Crédito - Beakt ESitef (Online)' && item.descTipo !== 'Cartão de Crédito - Beakt Sitef (Maquininha)' && item.descTipo !== 'Cartão de Débito - Beakt Sitef (Maquininha)') ?
                                                <div className={classes.rmvPg}>
                                                    <a href="#" onClick={() => handleRemovePagamento(item)}>
                                                        {t('button.remove')}
                                                    </a>
                                                </div>
                                                :
                                                <div>

                                                </div>
                                        }
                                    </div>
                                    <br />
                                </div>
                            ))}

                            <br />
                            <div className={classes.boxTotalizador}>
                                {t('sale.total_sale')}
                                <div className={classes.valueTotalizador}>
                                    {t('label.money_symbol')} {transformValueFloattoFormated(detalheVenda.valorTotal)}
                                </div>
                                <Clearfix />
                            </div>
                            <div className={classes.boxTotalizador}>
                                {t('sale.total_payments')}
                                <div className={classes.valueTotalizador}>
                                    {t('label.money_symbol')} {pgto && transformValueFloattoFormated(pgto.totalizadorPagamentos.valorTotalPago)}
                                </div>
                                <Clearfix />
                            </div>
                            <div className={classes.boxPendencia}>
                                {t('sale.balance_to_pay')}
                                <div className={classes.valuePendencia}>
                                    {t('label.money_symbol')} {pgto && transformValueFloattoFormated(pgto.totalizadorPagamentos.valorPendente)}
                                </div>
                            </div>
                            
                            <Clearfix />
                            
                            <hr />
                            <GridItem xs={12} sm={12} md={12}>
                                
                                <div style={{ width:'100%' }}>
                                    <TextField
                                        label={t('label.reason') + " *"}
                                        value={textMotivo}
                                        onChange={handleChangeMotivo}
                                        variant="outlined"
                                        name="motivo"
                                        InputLabelProps={{ shrink: true }}
                                        multiline
                                        rowsMax="3"
                                        rows="2"
                                        inputProps={{ maxLength: 150 }}
                                        ref={motivoInputRef}
                                        fullWidth
                                    />  
                                </div>
                                
                            </GridItem>
                            <hr />

                            <GridItem xs={12} sm={12} md={12}>
                                <br />

                                {messageReturn.show &&
                                    <div><div className="alertErrorEx alertmax">
                                        <p>
                                            {messageReturn.message}
                                        </p>
                                    </div><br />
                                    </div>
                                }

                                <div className={classes.tCenter}>
                                    <Button fullWidth color="info" onClick={() => handleSalvar()}>
                                        {t('button.save_sale')}
                                    </Button>

                                </div>
                            </GridItem>

                        </CardBody>
                    </Card>
                </GridItem>

            </GridContainer>
            <GridContainer className="mt-4">
                <GridItem xs={12} sm={12} md={12}>
                    <center>
                        <Button onClick={() => handleReturn()} color="transparent" >
                            {t('label.return')}
                        </Button>
                    </center>
                </GridItem>
            </GridContainer>
        </>
    );
}

